import { Component } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription } from 'rxjs';
import { Roles } from 'src/app/models/domain';
import { IQuickUrl, QuickUrlService } from 'src/app/state';

@Component({
  selector: 'em-edit-quick-url-drawer',
  styleUrls: ['./edit-quick-url-drawer.component.less'],
  templateUrl: './edit-quick-url-drawer.component.html',
  standalone: false,
})
export class EditQuickUrlDrawerComponent {
  public shortname?: string;
  public label?: string;
  public url?: string;
  public accessedBy?: string[];
  public listOfOptions = Object.values(Roles);
  public readonly trackByRef = trackByRef;
  public isSaving = false;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly quickUrlService: QuickUrlService,
    private readonly messageService: NzMessageService,
    private readonly drawerRef: NzDrawerRef
  ) {}

  public submitForm() {
    this.isSaving = true;

    if (this.shortname && this.label && this.url && this.accessedBy) {
      const data: IQuickUrl = {
        accessedBy: this.accessedBy,
        label: this.label,
        shortname: this.shortname,
        url: this.url,
      };

      this.subscriptions.add(
        this.quickUrlService.update(data).subscribe({
          next: () => {
            this.messageService.create('success', 'Successfully added URL');
            this.drawerRef.close();
          },
          error: (error: unknown) => {
            const errorMessage =
              error instanceof Error ? error.message : 'An unknown error occurred';

            this.messageService.create('error', errorMessage);
            this.isSaving = false;
          },
        })
      );
    }
  }
}
